import { AfterViewInit, Component, ElementRef, Inject, OnInit, Pipe, ViewChild } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { DomSanitizer, SafeHtml, SafeValue } from '@angular/platform-browser';
import {
  faAngleLeft,
  faAngleRight,
  faChevronLeft,
  faChevronRight,
  faFileExport,
  faInfoCircle,
  faMinus,
  faPlus,
  faProjectDiagram,
  faStepBackward,
  faStepForward,
  faUser,
  faTable,
  faLightbulb,
  faCircle,
  faSearch,
  faExchangeAlt,
  faArrowAltCircleRight
} from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { MainComponent } from '../main/main.component';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
import { PagerService } from '../shared/services/pager.service';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { ReloadToolService } from '../shared/services/reload-tool.service';
declare var $: any;
@Component({
  selector: 'app-persona-mapper-mind-map',
  templateUrl: './persona-mapper-mind-map.component.html',
  styleUrls: ['./persona-mapper-mind-map.component.scss']
})
export class PersonaMapperMindMapComponent implements OnInit, AfterViewInit {
  @ViewChild('interactionMapper', { static: false }) interactionMapper: ElementRef<any> | unknown;
  faCircle = faCircle;
  faChevronLeft = faChevronLeft;
  faLightbulb = faLightbulb;
  faChevronRight = faChevronRight;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;
  faSearch = faSearch;
  faArrowAltCircleRight = faArrowAltCircleRight;
  faFileExport = faFileExport;
  faProjectDiagram = faProjectDiagram;
  faUser = faUser;
  faInfoCircle = faInfoCircle;
  faConnectdevelop = faConnectdevelop;
  faPlus = faPlus;
  faMinus = faMinus;
  faTable = faTable;
  private allItems: any = [];
  pager: any = {};
  pagedItems: any = [];
  clickEventsubscriptionSocket: Subscription;
  clickEventsubscription: Subscription;
  GeniuneHTML: SafeHtml | undefined;
  currentView: any;
  personas: any;
  persona: any;
  foundDuplicate: any;
  moduleSelected: any = [];
  moduleFilter: any;
  searchText: any;
  triggerPipe: boolean = false;
  smartChecklist: boolean = true;
  syncModelDataObject: any;
  // interactionMapper: SafeHtml | undefined;
  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private Config: Config,
    private reloadToolService: ReloadToolService,
    private appService: AppService,
    public mainComponent: MainComponent,
    private pagerService: PagerService,
    private sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private treeDiagram: any
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
    this.clickEventsubscription = this._sharedService
      .getActiveData()
      .subscribe((data) => {
        this.reloadModelSyncActiveData(data);
      });
    this.clickEventsubscription = this._sharedService
      .getClickEvent()
      .subscribe((eut) => {
        // this.activate(eut);
      })
    // this.html = this.getInnerHTMLValue();
  }

  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  mapAciveAxisType: any = 'yAxis';

  /// ctrl variables
  //initialising the collection of xeuts grouped by type of the eut
  xeutCollection: any = { TF: [], UR: [], BF: [] };
  //initialising the collection of yeuts grouped by type of the eut
  yeutCollection: any = { TF: [], UR: [], BF: [] };
  personaMap: any;
  interactionMap: any;
  listOfEUTs: any;
  scopeMapper: any;
  selectedEUT: any;
  //To keep track of the selected X entity Type
  xEutType = "Feature";
  MapxEutType = "Personas";
  MapyEutType = "Feature";
  countFeature = '';
  //To keep track of the selected Y entity Type
  yEutType = "Feature";
  xMapPersona = true;
  xMapAttribute = true;
  xMapEut = true;
  EUTtypes = ["TF", "UR", "BF"];
  mapperFilterEtype = "UR";
  yMapPersona = false;
  yMapAttribute = false;
  yMapEut = true;

  interactionGraphStatus = true;
  interactionMapUI: any;
  MapxEutTypePersona: any = 'Persona';
  MapyEutTypePersona: any = 'Requirement';
  xMapAttributePersona: any = true;
  xMapEutPersona: any = true;
  yMapEutPerosna: any = true;
  MapxEutTypeScope: any = 'Attributes';
  MapyEutTypeScope: any = 'Feature';
  xMapAttributeScope: any = true;
  xMapEutScope: any = true;
  yMapAttributeScope: any = false;
  yMapEutScope: any = true;
  selectedHeaderName: any;
  entityInterTF: any = ' (0)';
  entityInterUR: any = ' (0)';
  entityInterBF: any = ' (0)';
  totalInterEntityCount: any = 0;
  modelData: any;
  disableDown: any;
  disableUp: any;
  disableDownY: any;
  disableUpY: any;
  firstEntity: any;
  html: any;
  foundEntity: any;

  /// model variables open
  // variable to keep track of starting index of map and list
  model: any = {
    xstartAt: 0,
    ystartAt: 0,
    xeutType: 'TF',
    yeutType: 'TF',
    maxColumns: 15,
    maxRows: 10,
    listLength: 10,
    xTabValid: true,
    iMap: {},
    xdeSelectCollection: this.Config.UIstates.interactionMapper.x,
    ydeSelectCollection: this.Config.UIstates.interactionMapper.y,
  };
  /// model close

  selectedEUTFound: any;





  ngOnInit(): void {

    setTimeout(() => {
      this.getVideoURL('Pm');
      this.changeAxisTab('yAxis');
    }, 2000);

    this.modelData = this._sharedService.loadedProjectData.model;
    // this.model = model;

    this.personaMap = this.modelData.personaMap;
    this.persona = this.modelData.persona;
    this.interactionMap = this.modelData.interactionMap;
    this.listOfEUTs = this.modelData.listOfEUTs;
    this.scopeMapper = this.modelData.scopeMapper;
    this.xeutCollection['TF'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'TF'
    );
    this.xeutCollection['UR'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'UR'
    );
    this.xeutCollection['BF'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'BF'
    );

    this.yeutCollection['TF'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'TF'
    );
    this.yeutCollection['UR'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'UR'
    );
    this.yeutCollection['BF'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'BF'
    );

    this.allItems = this.xeutCollection['TF'];

    /// entitymodel need to know
    this.selectedEUT = this.modelData.persona[0];
    // this.getMappingInteractionSelected(this.modelData.persona[0]);
    /// model init fns
    this.model.iMap = this.modelData.interactionMap;
    this.model.pMap = this.modelData.personaMap;
    // this.entityModel = this.modelData.entityModel; need to know
    //initialising the collection of interaction maps grouped by type of the eut
    this.model.interactionMap = { TF: [], UR: [], BF: [] };
    //initialising the collection of persona maps ui
    this.model.interactionMapUI = { TF: [], UR: [], BF: [] };
    //initialising the collection of deselected xeut ids grouped by the type of eut
    this.model.xdeSelectCollection = this.Config.UIstates.interactionMapper.x;
    //initialising the collection of deselected yeut ids grouped by the type of eut
    this.model.ydeSelectCollection = this.Config.UIstates.interactionMapper.y;
    this.setSelectedYEut('Feature');
    this.loadInteractionMap(
      this.model.iMap,
      this.xeutCollection,
      this.yeutCollection
    );
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    ///model int fn close
    this.isUpDownValid();
    this.isUpDownValidY();
    // this.setMappingSelectedXEut(this.MapxEutType, '');
    // this.setMappingSelectedyEut(this.MapyEutType, '');

    this.setMappingSelectedXEut(this.MapxEutType);
    this.setMappingSelectedyEut(this.MapyEutType);
    this.interactionGraphShowHide(false);

    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    // @ts-ignore: Object is possibly 'null'.
    // this.interactionMapper.nativeElement.innerHTML = "Hello Angular";
    // $(".radio-groups").each(() => {
    $(".radio-groups").find("input[type='radio']").first().prop('checked', true);
    // });
    setTimeout(() => {
      $('input[name="perosonaRadio"]').first().click();
    }, 100);
    this.reloadToolService.triggerSmartChecklist('');
  }

  reloadModelSyncActiveData(syncData: any) {
    // console.log("Active", syncData);
    if (syncData.type == "PMAP") {
      if (syncData.data.pType == this.selectedEUT.pType) {
        this.getMappingInteractionSelected(this.selectedEUT);
      } else {
      }
    }
  }
  openChatGPTassist() {
    this.mainComponent.openChatGPT();
    window.localStorage.setItem("assistantTool", "RECON");
    setTimeout(() => {
      // if (this.choosenEUT) {
      //   this.loadEntityDetails(this.choosenEUT);
      // }
    }, 500);
  }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
    if (this.smartChecklist == false) {
      $(".autoCursor").addClass('checklistIcon');
      this.smartChecklist = true;
    } else {
      $(".autoCursor").removeClass('checklistIcon');
      this.smartChecklist = false;
    }
  }
  getInnerHTMLValue() {
    // this.sanitizer.sanitize(this.sanitizer.bypassSecurityTrustHtml(this.html))
    this.GeniuneHTML = this.sanitizer.bypassSecurityTrustHtml(this.html);
  }
  ngAfterViewInit() {
    // this.GeniuneHTML = this.sanitizer.bypassSecurityTrustHtml(this.html);
    // // console.log('ngAfterViewInit exucuted');
    // // @ts-ignore: Object is possibly 'null'.
    // // console.log(this.interactionMapper.nativeElement); 
    // // @ts-ignore: Object is possibly 'null'.

    // if (this.interactionMapper.nativeElement) {
    //   // @ts-ignore: Object is possibly 'null'.

    //   this.interactionMapper.nativeElement.innerHTML = this.GeniuneHTML;

    // }
  }
  openTool(toolname: any) {
    this.currentView = toolname;
    localStorage.setItem('currentTool', toolname);
  }
  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }

  addToModuleFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.moduleSelected.push(id.mID);
      this.moduleFilter = id;
    } else {
      this.moduleFilter = '';
      var isPresent = this.moduleSelected.findIndex(
        (module: any) => module == id.mID
      );
      if (isPresent > -1) {
        this.moduleSelected.splice(isPresent, 1);
      }

    }
    if (this.triggerPipe == true) {
      this.triggerPipe = false;
    } else {
      this.triggerPipe = true;
    }
    // console.log(this.moduleSelected);
  }
  //function to get modulename by moduleID
  getModuleName(eut: any) {
    if (eut.mID) {
      var foundModule: any = this.modelData.modules.find(
        (mod: any) => mod.mID == eut.mID
      );
      return foundModule.mName;
    }

  }


  setPage(page: number) {
    // get pager object from servicesetPage
    this.pager = this.pagerService.getPager(this.allItems.length, page);
    // get current page of items
    this.pagedItems = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
    // if (this.pagedItems[0].mID) {
    //   this.pagedItems.sort((a: any, b: any) => a.mID.localeCompare(b.mID));
    // }
    // console.log("this.pagedItems", this.pagedItems);
    // .sort((a: any, b: any) => a.mID.localeCompare(b.mID))
  }








  onReloadInit(xeutCollection: any, yeutCollection: any, personaMap: any, interactionMap: any, listOfEUTs: any, scopeMapper: any) {
    // console.log('interaction mapper mindmap reload');
    this.xeutCollection = xeutCollection;
    this.yeutCollection = yeutCollection;
    this.personaMap = personaMap;
    this.interactionMap = interactionMap;
    this.listOfEUTs = listOfEUTs;
    this.scopeMapper = scopeMapper;

    // console.log('this.selectedEUT', this.selectedEUT);
    if (this.selectedEUT) {
      // this.selectedEUTFound = this.listOfEUTs.find((eut: any) => eut.eID == this.selectedEUT.eID);
      // if (this.selectedEUTFound) {
      //   this.getMappingInteractionSelected(this.selectedEUTFound);
      // } else {
      //   this.getMappingInteractionSelected(this.yeutCollection.TF[0]);
      // }
    }
  }

  //load the interaction map according to the shifted tab 
  //set the eut type and reset the value of start 
  setEUTtypeChosen(eutChosen: any) {
    this.model.xeutType = eutChosen;
    this.model.xstartAt = 0;
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    this.isUpDownValid();
  }

  //when select all is checked
  //empty my ids from delselected id list 
  // and change the value of check in the eid list also
  toggleAllDeselect(checkVal: any) {
    var controller = this;
    var listEnd = ((controller.xeutCollection[this.model.xeutType].length) > (this.model.xstartAt + this.model.listLength)) ? (this.model.xstartAt + this.model.listLength) : controller.xeutCollection[this.model.xeutType].length;

    for (var i = this.model.xstartAt; i < listEnd; i++) {
      if (checkVal) {
        var eID = this.model.xdeSelectCollection[this.model.xeutType].findIndex((eutID: any) => eutID == controller.xeutCollection[this.model.xeutType][i].eID);
        this.model.xdeSelectCollection[this.model.xeutType].splice(eID, 1);
      } else {
        var isPresent = this.model.xdeSelectCollection[this.model.xeutType].findIndex((eutID: any) => eutID == controller.xeutCollection[this.model.xeutType][i].eID);
        if (isPresent == -1) {
          controller.model.xdeSelectCollection[this.model.xeutType].push(controller.xeutCollection[this.model.xeutType][i].eID);
        }
      }
    }
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)

    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
  }

  toggleAllDeselectY(checkVal: any) {
    var controller = this;
    var listEnd = ((controller.yeutCollection[this.model.yeutType].length) > (this.model.ystartAt + this.model.listLength)) ? (this.model.ystartAt + this.model.listLength) : controller.yeutCollection[this.model.yeutType].length;

    for (var i = this.model.ystartAt; i < listEnd; i++) {
      if (checkVal) {
        var eID = this.model.ydeSelectCollection[this.model.yeutType].findIndex((eutID: any) => eutID == controller.yeutCollection[this.model.yeutType][i].eID);
        this.model.ydeSelectCollection[this.model.yeutType].splice(eID, 1);
      } else {
        var isPresent = this.model.ydeSelectCollection[this.model.yeutType].findIndex((eutID: any) => eutID == controller.yeutCollection[this.model.yeutType][i].eID);
        if (isPresent == -1) {
          controller.model.ydeSelectCollection[this.model.yeutType].push(controller.yeutCollection[this.model.yeutType][i].eID);
        }
      }
    }
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)

    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
  }

  toggleSelectionX(eID: any) {

    //if value is true -> remove from xdeselect list
    //if value is false -> add to xdeselect list
    var isPresent = this.model.xdeSelectCollection[this.model.xeutType].findIndex((eutID: any) => eutID == eID);
    // Is currently selected
    if (isPresent > -1) {
      this.model.xdeSelectCollection[this.model.xeutType].splice(isPresent, 1);
    }
    // Is newly selected
    else {
      this.model.xdeSelectCollection[this.model.xeutType].push(eID)
    }
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)

    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
  }

  toggleSelection(eID: any) {

    //if value is true -> remove from deselect list
    //if value is false -> add to deselect list
    var isPresent = this.model.xdeSelectCollection[this.model.xeutType].findIndex((eutID: any) => eutID == eID);
    // Is currently selected
    if (isPresent > -1) {
      this.model.xdeSelectCollection[this.model.xeutType].splice(isPresent, 1);
    }
    // Is newly selected
    else {
      this.model.xdeSelectCollection[this.model.xeutType].push(eID)
    }
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
  }

  toggleSelectionY(eID: any) {

    //if value is true -> remove from deselect list
    //if value is false -> add to deselect list
    var isPresent = this.model.ydeSelectCollection[this.model.yeutType].findIndex((eutID: any) => eutID == eID);
    // Is currently selected
    if (isPresent > -1) {
      this.model.ydeSelectCollection[this.model.yeutType].splice(isPresent, 1);
    }
    // Is newly selected
    else {
      this.model.ydeSelectCollection[this.model.yeutType].push(eID)
    }
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)

    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
  }

  nextPage() {
    var controller = this;

    //finding start of list
    var startPosition = this.model.xstartAt + this.model.listLength;

    //if length of list is greater such that there is a next page
    //set the start to the nextpage first element
    if ((controller.xeutCollection[this.model.xeutType].length) > (startPosition)) {
      this.model.xstartAt = startPosition;
      this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)

      this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    }
    this.isUpDownValid();
  }

  previousPage() {
    var controller = this;

    var startPosition = this.model.xstartAt - this.model.listLength;

    if (startPosition >= 0) {
      this.model.xstartAt = startPosition;
      this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection);
      this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    }
    this.isUpDownValid()
  }

  firstPage() {
    this.model.xstartAt = 0;
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    this.isUpDownValid();
  }

  lastPage() {
    var controller = this;
    this.model.xstartAt = controller.xeutCollection[this.model.xeutType].length - (controller.xeutCollection[this.model.xeutType].length % this.model.listLength);
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection);
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    this.isUpDownValid();
  }

  isUpDownValid() {
    var controller = this;
    controller.disableDown = ((controller.xeutCollection[this.model.xeutType].length) > (this.model.xstartAt + this.model.listLength)) ? true : false;
    controller.disableUp = (this.model.xstartAt - 1 >= 0) ? true : false;
  }

  isCheckedX(ID: any) {
    var eID = this.model.xdeSelectCollection[this.model.xeutType].findIndex((eutID: any) => eutID == ID);
    if (eID == -1) {
      return true;
    } else {
      return false;
    }
  }
  isCheckedY(ID: any) {
    var eID = this.model.ydeSelectCollection[this.model.yeutType].findIndex((eutID: any) => eutID == ID);
    if (eID == -1) {
      return true;
    } else {
      return false;
    }
  }
  //To set the selected XEUT type in the tabs - from Interaction Mapper
  setSelectedXEut(xEutType: any) {
    $('#yeut1M').hide();
    $('#xeut1M').show();
    this.xEutType = xEutType;
    if (xEutType == 'Requirement') {
      this.model.xeutType = 'UR';
      this.allItems = this.yeutCollection['UR'];
      this.setPage(1);
    } else if (xEutType == 'Feature') {
      this.model.xeutType = 'TF';
      this.allItems = this.yeutCollection['TF'];
      this.setPage(1);
    } else if (xEutType == 'Flow') {
      this.model.xeutType = 'BF';
      this.allItems = this.yeutCollection['BF'];
      this.setPage(1);
    }
    this.model.xstartAt = 0;
    this.model.xTabValid = true;
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    this.isUpDownValid();
  }

  //To set the selected XEUT type in the tabs - from Interaction Mapper
  setMappingSelectedXEut(MapxEutType: any, mapType?: any) {
    this.xMapPersona = false;
    this.xMapAttribute = false;
    this.xMapEut = true;
    this.MapxEutType = MapxEutType;
    if (MapxEutType == 'Requirement') {
      this.model.MapxEutType = 'UR';
      if (mapType == 'PM') {
        $('#xeutp1').show();
        $('#yeutp1').hide();
      }
      if (mapType == 'SM') {
        $('#xeuts1').show();
        $('#yeuts1').hide();
        this.scopeMapper.controller.selectedEutMap(this.xeutCollection.UR[0]);
      }
    } else if (MapxEutType == 'Feature') {
      if (mapType == 'SM') {
        $('#xeuts1').show();
        $('#yeuts1').hide();
      }
      this.model.MapxEutType = 'TF';
      this.scopeMapper.controller.selectedEutMap(this.xeutCollection.TF[0]);
    } else if (MapxEutType == 'Flow') {
      if (mapType == 'SM') {
        $('#xeuts1').show();
        $('#yeuts1').hide();
      }
      this.model.MapxEutType = 'BF';
      this.scopeMapper.controller.selectedEutMap(this.xeutCollection.BF[0]);
    } else if (MapxEutType == 'Persona') {
      this.model.MapxEutType = 'UR';
      this.xMapPersona = true;
      this.xMapAttribute = false;
      this.xMapEut = false;
      $('#xeutp1').show();
      $('#yeutp1').hide();
    } else if (MapxEutType == 'Attributes') {
      this.model.MapxEutType = 'BF';
      this.xMapPersona = false;
      this.xMapAttribute = true;
      this.xMapEut = false;
      if (mapType == 'SM') {
        $('#xeuts1').show();
        $('#yeuts1').hide();
      }
    }
    this.model.xstartAt = 0;
    this.model.xTabValid = true;
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    this.isUpDownValid();
  }
  //To set the selected YEUT type in the tabs - from Interaction Mapper
  setMappingSelectedyEut(MapyEutType: any, switchStatus?: any) {
    this.yMapPersona = false;
    this.yMapAttribute = false;
    this.yMapEut = true;
    this.MapyEutType = MapyEutType;
    if (MapyEutType == 'Requirement') {
      this.model.MapyEutType = 'UR';
      if (switchStatus == true || switchStatus == false) {
        $('#xeutp1').show();
        $('#yeutp1').hide();
      } else {
        $('#xeutp1').hide();
        $('#yeutp1').show();
      }
      if (switchStatus == true) {
        $('#xeuts1').show();
        $('#yeuts1').hide();
      } else if (switchStatus == false) {
        $('#xeuts1').hide();
        $('#yeuts1').show();
      } else {
        $('#xeuts1').hide();
        $('#yeuts1').show();
      }
    } else if (MapyEutType == 'Feature') {
      this.model.MapyEutType = 'TF';
      if (switchStatus == true || switchStatus == false) {
        $('#xeuts1').show();
        $('#yeuts1').hide();
      } else {
        $('#xeuts1').hide();
        $('#yeuts1').show();
      }
    } else if (MapyEutType == 'Flow') {
      this.model.MapyEutType = 'BF';
      if (switchStatus == true) {
        $('#xeuts1').show();
        $('#yeuts1').hide();
      } else if (switchStatus == false) {
        $('#xeuts1').hide();
        $('#yeuts1').show();
      } else {
        $('#xeuts1').hide();
        $('#yeuts1').show();
      }
    } else if (MapyEutType == 'Persona') {
      this.model.MapyEutType = 'TF';
      this.yMapPersona = true;
      this.yMapAttribute = false;
      this.yMapEut = false;
      if (switchStatus == true) {
        $('#xeutp1').show();
        $('#yeutp1').hide();
      } else if (switchStatus == false) {
        $('#xeutp1').hide();
        $('#yeutp1').show();
      } else {
        $('#xeutp1').hide();
        $('#yeutp1').show();
      }
    } else if (MapyEutType == 'Attributes') {
      this.model.MapyEutType = 'BF';
      this.yMapPersona = false;
      this.yMapAttribute = true;
      this.yMapEut = false;
      if (switchStatus == true) {
        $('#xeuts1').show();
        $('#yeuts1').hide();
      } else if (switchStatus == false) {
        $('#xeuts1').hide();
        $('#yeuts1').show();
      } else {
        $('#xeuts1').hide();
        $('#yeuts1').show();
      }
    }
    this.model.ystartAt = 0;
    this.model.xTabValid = false;
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    this.isUpDownValidY();
  }
  //To set the selected YEUT type in the tabs - from Interaction Mapper
  setSelectedYEut(yEutType: any) {
    // console.log("AAA");
    $('#yeut1M').show();
    $('#xeut1M').hide();
    this.yEutType = yEutType;
    this.allItems = this.modelData.persona;
    this.setPage(1);
    // if (yEutType == 'Requirement') {
    //   this.model.yeutType = 'UR';
    //   if (this.xeutCollection.UR[0]) {
    //     this.getMappingInteractionSelected(this.xeutCollection.UR[0]);
    //     this.allItems = this.yeutCollection['UR'];
    //     this.setPage(1);
    //   }
    // } else if (yEutType == 'Feature') {
    //   this.model.yeutType = 'TF';
    //   if (this.xeutCollection.TF[0]) {
    //     this.getMappingInteractionSelected(this.xeutCollection.TF[0]);
    //     this.allItems = this.yeutCollection['TF'];
    //     this.setPage(1);
    //   }
    // } else if (yEutType == 'Flow') {
    //   this.model.yeutType = 'BF';
    //   if (this.xeutCollection.BF[0]) {
    //     this.getMappingInteractionSelected(this.xeutCollection.BF[0]);
    //     this.allItems = this.yeutCollection['BF'];
    //     this.setPage(1);
    //   }
    // }
    this.model.ystartAt = 0;
    this.model.xTabValid = false;
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    this.isUpDownValidY();
  }

  isAllSelected() {
    var controller = this;
    var count = 0;
    var listEnd = ((controller.xeutCollection[this.model.xeutType].length) > (this.model.xstartAt + this.model.listLength)) ? (this.model.xstartAt + this.model.listLength) : controller.xeutCollection[this.model.xeutType].length;

    for (var i = this.model.xstartAt; i < listEnd; i++) {
      var isPresent = this.model.xdeSelectCollection[this.model.xeutType].findIndex((eutID: any) => eutID == controller.xeutCollection[this.model.xeutType][i].eID);
      if (isPresent > -1) {
        count++;
      }
    }
    var noOfRows = listEnd - this.model.xstartAt;
    if (count == 0) {
      return true;
    } else
      if (count == noOfRows || count < noOfRows) {
        return false;
      } else {
        return false;
      }

  }

  isAllSelectedY() {
    var controller = this;
    var count = 0;
    var listEnd = ((controller.yeutCollection[this.model.yeutType].length) > (this.model.ystartAt + this.model.listLength)) ? (this.model.ystartAt + this.model.listLength) : controller.yeutCollection[this.model.yeutType].length;

    for (var i = this.model.ystartAt; i < listEnd; i++) {
      var isPresent = this.model.ydeSelectCollection[this.model.yeutType].findIndex((eutID: any) => eutID == controller.yeutCollection[this.model.yeutType][i].eID);
      if (isPresent > -1) {
        count++;
      }
    }
    var noOfRows = listEnd - this.model.ystartAt;
    if (count == 0) {
      return true;
    } else
      if (count == noOfRows || count < noOfRows) {
        return false;
      } else {
        return false;
      }

  }

  nextPageY() {
    var controller = this;

    //finding start of list
    var startPosition = this.model.ystartAt + this.model.listLength;

    //if length of list is greater such that there is a next page
    //set the start to the nextpage first element
    if ((controller.yeutCollection[this.model.yeutType].length) > (startPosition)) {
      this.model.ystartAt = startPosition;
      this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection)
      this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    }
    this.isUpDownValidY();
  }

  previousPageY() {
    var controller = this;

    var startPosition = this.model.ystartAt - this.model.listLength;

    if (startPosition >= 0) {
      this.model.ystartAt = startPosition;
      this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection);
      this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    }
    this.isUpDownValidY()
  }

  firstPageY() {
    this.model.ystartAt = 0;
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection);
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    this.isUpDownValidY();
  }

  lastPageY() {
    var controller = this;
    this.model.ystartAt = controller.xeutCollection[this.model.yeutType].length - (controller.yeutCollection[this.model.yeutType].length % this.model.listLength);
    this.loadInteractionMap(this.model.iMap, this.xeutCollection, this.yeutCollection);
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
    this.isUpDownValidY();
  }

  isUpDownValidY() {
    var controller = this;
    controller.disableDownY = ((controller.yeutCollection[this.model.yeutType].length) > (this.model.ystartAt + this.model.listLength)) ? true : false;
    controller.disableUpY = (this.model.ystartAt - 1 >= 0) ? true : false;
  }


  entityExists(eType: any) {
    var entityPresent = this.entityExistsCheck(eType);
    return entityPresent;
  }

  getEntityType(eType: any) {
    var entityName = this.getEntityTypeCheck(eType);
    return entityName;
  }

  entityExistsCheck(eType: any) {
    var entities = this.modelData.listOfEUTs.filter(
      (entity: any) => entity.eType == eType
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getEntityTypeCheck(eType: any) {
    if (eType == 'TF') {
      return 'Features';
    } else if (eType == 'UR') {
      return 'Requirements';
    } else {
      return 'Flows';
    }
  }


  //
  generateReport(auto?: any) {
    let lanscapeArray = ['PersonaMapper'];
    window.localStorage.setItem('exportedData', JSON.stringify(lanscapeArray));
    window.localStorage.setItem('Entities', JSON.stringify(['TF', 'UR', 'BF']));
    if (auto == 'true') {
      window.open('/exportReport', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }

  resetActiveTab() {
    // console.log('resetActiveTab called in mindmap');
    $("#yAxisActiveTabM").removeClass('active');
    $("#yAxisFeatureM").removeClass('active');
    $("#yAxisRequirementM").removeClass('active');
    $("#yAxisFlowM").removeClass('active');
    $("#xAxisActiveTabM").removeClass('active');
    $("#xAxisFeatureM").removeClass('active');
    $("#xAxisRequirementM").removeClass('active');
    $("#xAxisFlowM").removeClass('active');
    $("#yAxisActiveTabM").addClass('active');
    $("#yAxisFeatureM").addClass('active');
    this.setSelectedXEut('Requirement');
    // this.setSelectedYEut('Feature');
    $('#yeut1M').show();
    $('#xeut1M').hide();
  }

  interactionGraphShowHide(graphStatus: any) {
    this.resetActiveTab();
    if (graphStatus == false) {
      $('.interactionTableView').hide();
      $('.interactionGraph').show();
      this.interactionGraphStatus = true;
      // this.selectedEUT = this.listOfEUTs[0];
      this.firstEntity = this.listOfEUTs.find((eut: any) => eut.eType == 'TF');
      if (this.firstEntity) {
        // this.getMappingInteractionSelected(this.firstEntity);
      }
    } else {
      $('.interactionTableView').show();
      $('.interactionGraph').hide();
      this.interactionGraphStatus = false;
      this.selectedEUT = '';
    }
  }
  // activate(eut: any) {
  //   // console.log("eut1222222222",eut);
  //   if (eut.toolType == 'im') {
  //     console.log('eutDeeepdive', eut);
  //     let selectedType = '';
  //     if(eut.eType == 'TF'){
  //       selectedType = 'Feature';
  //     }else if(eut.eType == 'UR'){
  //       selectedType = 'Requirement';
  //     }else if(eut.eType == 'BF'){
  //       selectedType = 'Flow';
  //     }
  //     this.setSelectedYEut(selectedType);
  //     setTimeout(() => {
  //       this.getMappingInteractionSelected(eut);

  //     }, 1000);
  //     // this.index = this.eutTypes.findIndex((type) => type == eut.eType);
  //   }
  // }


  getMappingInteractionSelected(eut: any) {
    // console.log("eut Default",eut);
    this.entityInterTF = " (0)";
    // console.log("eut", eut);
    this.entityInterUR = " (0)";
    this.entityInterBF = " (0)";
    this.totalInterEntityCount = 0;
    this.selectedEUT = eut;
    if (eut) {
      this.selectedHeaderName = eut.pName;
      this.getMappingInteraction();
      this.loadInteractionMapper();
    }
    $('#yeut1').click();
  }

  getMappingInteraction() {
    $('#wrapperInteraction').remove();
    var dispArray = [];
    this.html = '<div id="wrapperInteraction"><span class="label labelInterTitle">' + this.selectedHeaderName + '</span><div class="branch lv1">';
    var toggleName = "'" + this.EUTtypes[1] + "'";
    for (var j = this.personaMap.length - 1; j >= 0; j--) {
      if (this.selectedEUT.pType == this.personaMap[j].pType) {
        this.foundEntity = this.listOfEUTs.find((eut: any) => eut.eID == this.personaMap[j].eID && eut.eType == "UR");
        if (this.foundEntity) {
          this.foundDuplicate = dispArray.find((eut: any) => eut.eID == this.foundEntity.eID);
          if (!this.foundDuplicate) {
            dispArray.push(this.foundEntity);
          }
          this.html += '<div class="' + this.EUTtypes[1] + ' ' + this.EUTtypes[1] + 'sample' + ' entry"><span class="label stage3label">' + this.getModuleName(this.foundEntity) + ' | ' + this.foundEntity.eName + '</span></div>';
        }
      }
    }
    this.html += '</div></div>';
    var valueArr = dispArray.map(function (item) { return item.eType });
    var counts: any = {};
    valueArr.forEach(function (x: any) { counts[x] = (counts[x] || 0) + 1; });
    // console.log("valueArr",valueArr);
    if (counts.TF != undefined) {
      this.entityInterTF = ' (' + counts.TF + ')';
    } else {
      this.entityInterTF = " (0)";
    }
    if (counts.UR != undefined) {
      this.entityInterUR = ' (' + counts.UR + ')';
    } else {
      this.entityInterUR = " (0)";
    }
    if (counts.BF != undefined) {
      this.entityInterBF = ' (' + counts.BF + ')';
    } else {
      this.entityInterBF = " (0)";
    }
    this.totalInterEntityCount = dispArray.length;
    $("#interactionMapper").append(this.html);
    // @ts-ignore: Object is possibly 'null'.
    // this.interactionMapper.nativeElement.innerHTML = 
    // this.getInnerHTMLValue();
    // if (valueArr.length <= 1 || counts.TF <= 1) { .insertAdjacentHTML('beforeend', this.getInnerHTMLValue());
    $('#wrapperInteraction').css('margin-top', '1.5em');
    // }
    $('#entityInterTF').html(this.entityInterTF);
    $('#entityInterUR').html(this.entityInterUR);
    $('#entityInterBF').html(this.entityInterBF);
    this.totalInterEntityCount = dispArray.length;
    var titleFeature = '[' + this.selectedEUT.pName + ']';
    $('.selectedHeaderNameClassInteraction').html(titleFeature);
    if (this.totalInterEntityCount <= 1) {
      this.countFeature = 'interacts with (' + this.totalInterEntityCount + ' entity)';
    } else {
      this.countFeature = 'interacts with (' + this.totalInterEntityCount + ' entities)';
    }
    $('.selectedHeaderCountInteraction').html(this.countFeature);
    // console.log("count", this.countFeature);
    var dynamicDivWidth = $(".labelInterTitle").width();
    if (dynamicDivWidth <= 126) {
      $('.labelInterTitle').addClass('labelEUTTitle1');
      $('.lv1').addClass('lv1Int1');
      $('.labelInterTitle').attr('title', this.selectedEUT.eName);
    } else if (dynamicDivWidth > 126 && dynamicDivWidth <= 226) {
      $('.labelInterTitle').addClass('labelEUTTitle2');
      $('.lv1').addClass('lv1Int2');
      $('.labelInterTitle').attr('title', this.selectedEUT.eName);
    } else if (dynamicDivWidth > 226 && dynamicDivWidth <= 326) {
      $('.labelInterTitle').addClass('labelEUTTitle3');
      $('.lv1').addClass('lv1Int3');
      $('.labelInterTitle').attr('title', this.selectedEUT.eName);
    } else if (dynamicDivWidth > 326 && dynamicDivWidth <= 426) {
      $('.labelInterTitle').addClass('labelEUTTitle4');
      $('.lv1').addClass('lv1Int4');
      $('.labelInterTitle').attr('title', this.selectedEUT.eName);
    } else {
      $('.labelInterTitle').addClass('labelEUTTitle5');
      $('.lv1').addClass('lv1Int5');
      $('.labelInterTitle').attr('title', this.selectedEUT.eName);
      $('.selectedHeaderNameClassInteraction').attr('title', this.selectedEUT.eName);
      $('.selectedHeaderNameClassInteraction').addClass('graphAreaHeaderEllipsis');
    }
    if (counts.TF == undefined) {
      $('.iconsTF').addClass('noneDisplay');
    }
    if (counts.UR == undefined) {
      $('.iconsUR').addClass('noneDisplay');
    }
    if (counts.BF == undefined) {
      $('.iconsBF').addClass('noneDisplay');
    }
    var duplicates = valueArr.reduce(function (acc, el, i, arr) {
      if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
    }, []);
    for (var m = 0; m < this.EUTtypes.length; m++) {
      if (valueArr.indexOf(this.EUTtypes[m]) > -1) {
        if (this.EUTtypes[m] == "TF") {
          $(".TFstage2Inter").removeClass('TFstage2branch');
        } else if (this.EUTtypes[m] == "UR") {
          $(".URstage2Inter").removeClass('URstage2branch');
        } else if (this.EUTtypes[m] == "BF") {
          $(".BFstage2Inter").removeClass('BFstage2branch');
        }
      }
    }
    for (var k = 0; k < duplicates.length; k++) {
      if (duplicates[k] == "TF") {
        $(".TFsample").removeClass(duplicates[k]);
      } else if (duplicates[k] == "UR") {
        $(".URsample").removeClass(duplicates[k]);
      } else if (duplicates[k] == "BF") {
        $(".BFsample").removeClass(duplicates[k]);
      }
    }
    $('.lv2').hide();
  }

  isCheckedEntity(eID: any) {
    for (var i = 0; i < this.personaMap.length; i++) {
      if (this.personaMap[i].pType == this.selectedEUT.pType && this.personaMap[i].eID == eID) {
        return true;
      }
    }
    return false;
  }





  //Construct the interaction map for each eut type and load the map collection 
  //after constructing check the interaction map and mark * if there is a mapping for the eut with other eut

  //here y collection is the rows 
  //x collection is the columns
  loadInteractionMap(iMap: any, xeutCollection: any, yeutCollection: any) {

    // var model = this;
    for (var key in yeutCollection) {

      this.model.interactionMap[key] = [];

      yeutCollection[this.model.yeutType].forEach((yEut: any) => {
        var eutList: any = [];
        xeutCollection[this.model.xeutType].forEach((xEut: any) => {

          var mapped = iMap.find(function (amap: any) {
            return (yEut.eID == amap.eut1 && xEut.eID == amap.eut2);
            //return (aEut.eID == amap.eut1);
          });
          if (mapped) {
            eutList.push({ eID: xEut.eID, map: "*" });
          }
          else if (!mapped) {
            eutList.push({ eID: xEut.eID, map: "" });
          }
        });
        this.model.interactionMap[key].push({ eID: yEut.eID, yindex: yeutCollection[this.model.yeutType].indexOf(yEut), eutList });
      });
    }
  }

  loadInteractionMapUI(xeutCollection: any, yeutCollection: any) {
    // var model = this;
    //alert('GUI start....'+eutCollection);
    for (var key in yeutCollection) {

      //cloning the interaction map to interaction map ui 
      this.model.interactionMapUI[key] = $.extend(true, [], this.interactionMap[key]);

      this.model.interactionMapUI[key].splice(0, this.model.ystartAt);

      //for every entity 
      //start from the list index in interactionmapUI 
      //check whether eid in eut is in the deselected list and splice it 
      //loop till max columns
      for (i = this.model.interactionMapUI[key].length - 1; i >= 0; i -= 1) {
        if (this.model.ydeSelectCollection[this.model.yeutType].length > 0) {
          var yidExistIndex = this.model.ydeSelectCollection[this.model.yeutType].findIndex((id: any) => id == this.model.interactionMapUI[key][i].eID);
          if (yidExistIndex > -1) {
            this.model.interactionMapUI[key].splice(i, 1);
          }
        }
      }

      if (this.model.interactionMapUI[key].length > this.model.maxRows) {
        this.model.interactionMapUI[key].splice(this.model.maxRows, this.model.interactionMapUI[key].length - this.model.maxRows);
      }



      this.model.interactionMapUI[key].forEach((aEut: any) => {

        for (i = aEut.eutList.length - 1; i >= this.model.xstartAt; i -= 1) {
          var idExist = this.model.xdeSelectCollection[key].find((id: any) => id == aEut.eutList[i].eID);
          if (idExist) {
            aEut.eutList.splice(i, 1);
          }
        }

        aEut.eutList.splice(0, this.model.xstartAt);
        if (aEut.eutList.length > this.model.maxColumns) {
          aEut.eutList.splice(this.model.maxColumns, aEut.eutList.length - this.model.maxColumns);
        }

        for (var i = aEut.eutList.length; i < this.model.maxColumns; i++) {
          aEut.eutList.push({ map: "-1" });
        }
      })

      //adding rows and columns to match the max rows and columns
      for (var i = this.model.interactionMapUI[key].length; i < this.model.maxRows; i++) {
        var eutList = []
        for (var j = 0; j < this.model.maxColumns; j++) {
          eutList.push({ map: "-1" });
        }
        this.model.interactionMapUI[key].push({ name: "", eutList });
      }
      //for the last row of index
      //check if eid exist in deselected list
      //if exist then skip it
      var eutList = [];

      for (var i = this.model.xstartAt; i < xeutCollection[key].length; i++) {
        var idExist = this.model.xdeSelectCollection[key].find((id: any) => id == xeutCollection[key][i].eID);
        if (!idExist && eutList.length < this.model.maxColumns) {
          eutList.push({ map: i + 1 });
        }
      }
      for (var j = eutList.length; j < this.model.maxColumns; j++) {
        eutList.push({ map: "-1" });
      }
      this.model.interactionMapUI[key].push({ name: "", eutList });
    }

  }

  // Handler to update the UI InteractionMap model & teh actual InteractionMap model
  mapEUT(eut1Chosen: any, eut2Chosen: any, id: any) {
    // Update the UI Interaction Map Model
    eut1Chosen.eutList[eut2Chosen].map = (eut1Chosen.eutList[eut2Chosen].map == "*") ? "" : "*";

    // Npw update the "actual" Interaction Map model
    var p = this.interactionMap[this.model.xeutType].find((aEut: any) => aEut.eID == eut1Chosen.eID);
    p.eutList[eut2Chosen].map = (p.eutList[eut2Chosen].map == "*") ? "" : "*";

    var mappingExist = this.model.iMap.find((map: any) => map.eut1 == eut1Chosen.eID && map.eut2 == id);
    if (mappingExist) {
      this.delete(id, eut1Chosen.eID);
    } else {
      this.add(id, eut1Chosen.eID);
    }
  }


  //From here below was existing
  getInteractionMappingForAnEut(eutID: any) {
    var mappedEutForEut = this.model.iMap.filter((map: any) => map.eut1 == eutID);
    return mappedEutForEut;
  }

  loadInteractionMapper() {
    this.loadInteractionMap(
      this.model.iMap,
      this.xeutCollection,
      this.yeutCollection
    );
    this.loadInteractionMapUI(this.xeutCollection, this.yeutCollection);
  }

  mapEntity(checked: any, eID: any, pType: any) {
    // console.log('checked.target.checked', checked.target.checked);
    if (checked.target.checked == true) {
      this.add(eID, pType);
    } else {
      this.delete(eID, pType);
    }
  }

  add(eID: any, pType: any) {
    this.model.pMap.push({ pType: pType, eID: eID })
    this.syncModelDataObject = {
      "type": "PMAP",
      "operation": "CREATE",
      "data": { pType: pType, eID: eID }
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }

  delete(eID: any, pType: any) {
    var index = this.model.pMap.findIndex((map: any) => map.pType == pType && map.eID == eID);
    if (index > -1) {
      this.model.pMap.splice(index, 1);
    }
    this.syncModelDataObject = {
      "type": "PMAP",
      "operation": "DELETE",
      "data": { pType: pType, eID: eID }
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }



  getVideoURL(urlName: any) {
    var videoURL = this.appService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }

  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, iframe => {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'stopVideo'
      }), '*');
    });
  }

  changeAxisTab(type: any) {
    this.mapAciveAxisType = type;
  }
  goToView() {
    // console.log('view called in main component');
    window.open('/exportReport', '_blank');
    // window.open(appConst.redirectHostAddress + "export", "_blank");
  }

}
